import { Fragment, useLayoutEffect, useState } from "react";
import Popup from "../LiveScoreCardpopups/Popup";

export default function NewVenuePlans() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [show, setShow] = useState(false);

  useLayoutEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [plan, setPlans] = useState(0);

  const plansData = [
    {
      planName: "Pro Plan",
      // offermonthlyPrice: 999,
      // offerannualPrice: 9999,
      monthlyPrice: 1999,
      annualPrice: 20389,
      features: [
        "3 Default Views",
        "Dashboard Access",
        "WhatsApp Notifications",
        "Easy Slot Booking View",
        "Unlimited Staff Members",
        "Promoted Listing",
        "1 Instagram Reel Collab & Post (1 per quarter)",
        "Special Package Plan Offer Included",
        "Commission Free Bookings",
      ],
    },
    {
      planName: "Basic Plan",
      monthlyPrice: 1099,
      annualPrice: 11200,
      features: [
        "2 Default Views",
        "Dashboard Access",
        "1 Staff Member",
        "Special Package Plan Offer Included",
        "Commission Free Bookings",
      ],
    },

    {
      planName: "Commission Plan",
      features: [
        "3 Default Views",
        "Dashboard Access",
        "WhatsApp Notifications",
        "Easy Slot Booking View",
        "Unlimited Staff Members",
        "Special Package Plan Offer Included",
      ],
    },
  ];

  return (
    <Fragment>
      {windowWidth > 768 ? (
        <img
          src="/images/PricingPlanBg.svg"
          className="w-100 position-absolute"
        />
      ) : (
        <img
          src="/images/PricingPlanMobileBg.svg"
          className="w-100 position-absolute"
        />
      )}
      {/* <div className="new-plans-banner-bg"/> */}
      <div className="container-lg position-relative Montserrat">
        <h1 className="text-center plans-banner-heading pt-md-5 pt-4 fw-bold">
          More Bookings, Less Hassle - Smart Pricing for Smart Turfs
        </h1>
        <h6 className="text-center text-white fw-400 pt-2 pt-md-0 my-3">
          Manage bookings, payments, and customers with ease
        </h6>
        <div className="d-flex justify-content-center align-items-center fw-400  pb-md-3 pb-3">
          <div
            className="d-flex bg-white rounded-pill my-3 my-md-4"
            style={{ padding: "2px" }}
          >
            <label
              className={`px-4 px-md-5 py-1 py-md-2 cursor-pointer ${
                plan === 0
                  ? "new-plans-bg-color rounded-pill text-white"
                  : "new-plans-color"
              } fw-600`}
              onClick={() => setPlans(0)}
            >
              Monthly
            </label>
            <label
              className={`px-4 px-md-5 py-1 py-md-2 cursor-pointer ${
                plan === 1
                  ? "new-plans-bg-color rounded-pill text-white"
                  : "new-plans-color"
              } fw-600`}
              onClick={() => setPlans(1)}
            >
              Annually
            </label>
          </div>
        </div>
        <div className="col-12 plans-banner-heading specialoffer text-center ">
          {/* <label className="plans-banner-heading fw-500 fade-text">
            <b>50% OFF</b> Limited-Time Diwali Offer -{" "}
          </label>{" "}
          Get our Pro plan for even less than the Basic plan price! <br /> */}
          <i
            className="text-decoration-underline cursor-pointer"
            style={{ fontSize: "16px" }}
            onClick={() => {
              setShow(true);
            }}
          >
            (Click here to view activation steps)
          </i>
        </div>
        <div className="row mt-md-4 mt-5">
          {plansData.map((item, index) => (
            <div className="col-md-4 col-12 mb-4 mb-md-0">
              <div className="p-4 new-plan-card-border bg-white">
                <div
                  className="d-flex align-items-center justify-content-between pb-3 new-plans-border-bottom flex-column"
                  style={{ height: "60px" }}
                >
                  <label className="new-plans-color fw-semibold">
                    {item.planName}
                  </label>
                  <label className="new-plans-color text-end">
                    {item?.offermonthlyPrice && item?.offerannualPrice ? (
                      <span
                        className={`${index === 2 ? "d-none" : ""} fw-bolder`}
                        style={{ fontSize: "20px" }}
                      >
                        Rs{" "}
                        {plan === 0
                          ? item.offermonthlyPrice
                          : item.offerannualPrice}
                        <label className="text-decoration-line-through px-1 custom-fs-14 fw-normal">
                          {plan === 0 ? item.monthlyPrice : item.annualPrice}
                        </label>
                        /
                      </span>
                    ) : (
                      <span
                        className={`${index === 2 ? "d-none" : ""} fw-bolder`}
                        style={{ fontSize: "20px" }}
                      >
                        Rs {plan === 0 ? item.monthlyPrice : item.annualPrice}/
                      </span>
                    )}{" "}
                    <span
                      className={`${index === 2 ? "d-none" : ""} custom-fs-14`}
                    >
                      {plan === 0 ? "Monthly" : "Annually"}
                    </span>{" "}
                  </label>
                </div>
                <ul className="mt-3 list-unstyled px-0">
                  {item.features.map((feature) => (
                    <li className="row w-100 mb-3 fw-600 mx-0 align-items-center">
                      <img
                        src="/images/PlansDoubleTick.svg"
                        className="col-1 px-0"
                        width={20}
                        height={20}
                      />
                      <label className="ps-2 plans-list-color col-11 px-0 custom-fs-14">
                        {feature}
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
        <div className=" plan-list-add-on mt-3 mt-md-5 Montserrat">
          <label className="w-100 py-4 text-center fw-bolder plans-banner-heading">
            Add On
          </label>
          <div className="row pb-3 mx-2 mx-md-0">
            <div className="col-md-4 col-12 px-md-4 px-2 mb-3 mb-md-0">
              <div className="bg-white border-10 d-flex flex-column justify-content-center align-items-center p-4">
                <label className="w-100 text-center text-black fw-semibold">
                  Promoted Listing
                </label>
                <label className="w-100 text-center fw-semibold new-plans-color">
                  Rs 1500/-
                </label>
              </div>
            </div>
            <div className="col-md-4 col-12 px-md-4 px-2 mb-3 mb-md-0">
              <div className="bg-white border-10 d-flex flex-column justify-content-center align-items-center p-4">
                <label className="w-100 text-center text-black fw-semibold">
                  Whitelabel Customized Page
                </label>
                <label className="w-100 text-center fw-semibold new-plans-color">
                  Rs 5000/-
                </label>
              </div>
            </div>
            <div className="col-md-4 col-12 px-md-4 px-2 mb-3 mb-md-0">
              <div className="bg-white border-10 d-flex flex-column justify-content-center align-items-center p-4">
                <label className="w-100 text-center text-black fw-semibold">
                  Organic Promotion on Instagram
                </label>
                <label className="w-100 text-center fw-semibold new-plans-color">
                  Rs 1500/-{" "}
                  <span
                    className="custom-fs-14 fw-normal"
                    style={{ color: "#000000c2" }}
                  >
                    (1 per Quater)
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      {show && (
        <Popup show={show} onHide={() => setShow(false)} venueflag={1}>
          <h4>Here are steps how to purchase plan:</h4>

          <ol>
            <li>Log in to your account.</li>
            <li>Go to your Venue Dashboard.</li>
            <li>Click on Bookings.</li>
            <li>Next to your current plan, click View details.</li>
            <li>Find the Pro plan and click View details again.</li>
            <li>Complete the upgrade process.</li>
          </ol>
          <img
            className="img-fluid"
            src="/images/stepstobuy.png"
            alt="Steps to Purchase Plan"
          />
        </Popup>
      )}
    </Fragment>
  );
}
